import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GetPrompt.graphql';
import { Query, QuerygetPromptArgs } from '../../__generated__/globalTypes';

export const useGetPromptQuery = (options?: QueryHookOptions<Query, QuerygetPromptArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerygetPromptArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGetPromptLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerygetPromptArgs>
): QueryResult<Query, QuerygetPromptArgs> & { getGetPrompt: LazyQueryExecFunction<Query, QuerygetPromptArgs> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getGetPrompt, result] = useLazyQuery<Query, QuerygetPromptArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGetPrompt, ...result };
};

export const useGetPromptPromiseQuery = () => {
  const client = useApolloClient();

  const getGetPrompt = useCallback(
    (options?: Omit<QueryOptions<QuerygetPromptArgs, Query>, 'query'>) =>
      client.query<Query, QuerygetPromptArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getGetPrompt };
};
// Suspense Query Hooks
export const useGetPromptSuspenseQuery = (options?: SuspenseQueryHookOptions<Query, QuerygetPromptArgs>) => {
  const result = useSuspenseQuery<Query, QuerygetPromptArgs>(QUERY, {
    ...options
  });

  return result;
};
